import { Box, Button } from "@drone-js/core";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useOnboardingRouteId } from "../useOnboardingRouteId";
import { usePostPublishViewModelValue } from "./postPublishViewModelAtom";

export const CallToAction = () => {
    const {
        cmsData: {
            complete: { addNewListingText, manageListingText },
        },
    } = useStaticDataAtomValue();
    const { lang } = useOnboardingRouteId();
    const { manageListingUrl } = usePostPublishViewModelValue();

    return (
        <Box display="flex" justifyContent="end" flexDirection="column-reverse" qM={{ flexDirection: "row" }}>
            <Box me="0" mt="16" qM={{ me: "16", mt: "0" }}>
                <Button
                    variant="label"
                    size="l"
                    hierarchy="secondary"
                    label={addNewListingText}
                    data-element-name="add-new-listing"
                    href={`/${lang}/list-my-property/get-started`}
                />
            </Box>
            <Button
                variant="label"
                size="l"
                hierarchy="secondary"
                data-element-name="manage-listing"
                label={manageListingText}
                href={manageListingUrl}
            />
        </Box>
    );
};
